<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <input
            type="button"
            :value="cancelButton"
            class="cancel_button"
            @click="cancel"
          />
          <input
            type="button"
            :value="finishButton"
            class="finish_button"
            @click="update"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="post_id detail_content">
            <div class="post_id_label detail_label">
              {{ postIdLabel }}
            </div>
            <div id="post_id">
              {{ post.postId }}
            </div>
          </div>
          <div class="post_name detail_content">
            <div class="post_name_label detail_label">
              {{ postNameLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="post.postName"
              @input="inputUpdate('postName')"
            />
          </div>
          <div class="post_code detail_content">
            <div class="post_code_label detail_label">
              {{ postCodeLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="post.postCode"
              @input="inputUpdate('postCode')"
            />
          </div>
          <div class="post_parent detail_content">
            <div class="post_parent_label detail_label">
              {{ postParentLabel }}
            </div>
            <select
              class="drop_down_list"
              @change="inputUpdate('parentPostId')"
            >
              <option value=""></option>
              <option disabled selected value="">{{
                post.parentPostName
              }}</option>
              <option
                v-for="post in posts"
                :value="post.postId"
                :key="post.postId"
              >
                {{ post.postName }}
              </option>
            </select>
          </div>
          <div class="users">
            <div class="users_label detail_label">
              {{ usersLabel }}
            </div>
            <div class="table">
              <table
                class="table_header"
                border="1"
                cellpadding="2"
                bordercolor="#fff"
                style="border-collapse: collapse"
              >
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      class="checkbox"
                      :checked="usersChecked"
                      @click="allCheckedUsersAction"
                    />
                  </th>
                  <th>
                    {{ userNameLabel }}
                  </th>
                </tr>
                <tr
                  v-for="user in users"
                  :key="user.userId"
                  class="item_table_row"
                >
                  <td @click="checkedUsersAction(user)">
                    <input
                      type="checkbox"
                      class="checkbox"
                      :checked="user.postPriorityFlag"
                    />
                  </td>
                  <td @click="checkedUsersAction(user)">
                    {{ user.userName }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="edit_bottom">
        <input
          type="button"
          :value="deleteButton"
          class="edit_delete_button"
          @click="showModal = true"
        />
      </div>
      <div class="modal_window" v-if="showModal">
        <modalWindow
          :question="deleteWord"
          :router="router"
          @close="stayClose"
          @remove="remove"
        >
        </modalWindow>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import modalWindow from '../modalWindow/detailDeleteModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      finishButton: '完了',
      deleteButton: 'この情報を削除',
      postIdLabel: '所属ID',
      postNameLabel: '所属名',
      postCodeLabel: '所属コード',
      postParentLabel: '親所属',
      usersLabel: '表示拠点',
      userNameLabel: '拠点名',
      router: '/belongs',
      deleteWord: 'この情報を削除してよろしいですか？',
      completeWord: '',
      failureWord: '',
      usersChecked: false,
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false
    }
  },
  computed: {
    post() {
      return this.$store.state.belongs.post
    },
    users() {
      return this.$store.state.belongs.users
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    },
    posts() {
      // 自身を除く所属を取得
      let postParent = []
      for (let i = 0; i < this.$store.state.belongs.allPosts.length; i++) {
        if (this.post.postId !== this.$store.state.belongs.allPosts[i].postId) {
          postParent.push(this.$store.state.belongs.allPosts[i])
        }
      }
      return postParent
    }
  },
  components: {
    modalWindow,
    completeModalWindow,
    loadingModalWindow
  },
  async created() {
    this.$store.dispatch('belongs/inputUpdate', {
      name: 'parentPostId',
      value: this.$store.state.belongs.post.parentPostId
    })
    this.$store.dispatch('belongs/setAllPosts')
  },
  methods: {
    checkedUsersAction(e) {
      // クリックしたリストのチェックボックスをチェックする。
      this.$store.dispatch('belongs/checkedUsersAction', e)
    },
    allCheckedUsersAction(e) {
      // ポストリストのチェックボックスを全てチェックする。
      this.usersChecked = !this.usersChecked
      for (let i = 0; i < this.users.length; i++) {
        this.users[i].postPriorityFlag = this.usersChecked
      }
    },
    inputUpdate(e) {
      this.$store.dispatch('belongs/inputUpdate', {
        name: e,
        value: event.target.value
      })
    },
    async cancel(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'belongs/setDetailPost',
          this.$store.state.belongs.post
        )
        this.$router.push('../belongs/detail')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_220001
        let eventType = 3
        let reason = 'MSGCRC0036 '
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0036.name +
            this.errorMsg.MSGCRC0036.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    async update(e) {
      this.showloadingModal = true
      var users = []
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].postPriorityFlag === true) {
          users.push({
            userId: this.users[i].userId,
            postPriorityFlag: this.users[i].postPriorityFlag
          })
        }
      }
      try {
        await this.$store.dispatch('belongs/updatePost', users)
        this.$emit('list-reload')
        this.$router.push('../belongs/detail')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_220003
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0033') {
            this.failureWord =
              this.errorMsg.MSGCRC0033.name +
              this.errorMsg.MSGCRC0033.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0101') {
            this.failureWord =
              this.errorMsg.MSGCRC0101.name +
              this.errorMsg.MSGCRC0101.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0147') {
            this.failureWord =
              this.errorMsg.MSGCRC0147.name +
              this.errorMsg.MSGCRC0147.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0148') {
            this.failureWord =
              this.errorMsg.MSGCRC0148.name +
              this.errorMsg.MSGCRC0148.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0149') {
            this.failureWord =
              this.errorMsg.MSGCRC0149.name +
              this.errorMsg.MSGCRC0149.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0150') {
            this.failureWord =
              this.errorMsg.MSGCRC0150.name +
              this.errorMsg.MSGCRC0150.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0151') {
            this.failureWord =
              this.errorMsg.MSGCRC0151.name +
              this.errorMsg.MSGCRC0151.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0152') {
            this.failureWord =
              this.errorMsg.MSGCRC0152.name +
              this.errorMsg.MSGCRC0152.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.failureWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.failureWord =
              this.errorMsg.MSGCRC0037.name +
              this.errorMsg.MSGCRC0037.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0037'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0037.name +
            this.errorMsg.MSGCRC0037.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      try {
        await this.$store.dispatch(
          'belongs/setDetailPost',
          this.$store.state.belongs.post
        )
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_220002
        let eventType = 3
        let reason = 'MSGCRC0036 '
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0036.name +
            this.errorMsg.MSGCRC0036.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push(this.router)
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    async remove(e) {
      this.showloadingModal = true
      let postId = this.$store.state.belongs.post.postId
      let deleteList = [{postId}]
      try {
        await this.$store.dispatch('belongs/deletePosts', deleteList)
        this.$emit('list-reload')
        this.showModal = false
        this.completeWord = '削除しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_220004
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0129') {
            this.failureWord =
              this.errorMsg.MSGCRC0129.name +
              this.errorMsg.MSGCRC0129.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.failureWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.failureWord =
              this.errorMsg.MSGCRC0038.name +
              this.errorMsg.MSGCRC0038.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showModal = false
        this.showFailureModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
.table_header {
  height: 30px;
}
tr {
  height: 40px;
}
th,
td {
  table-layout: fixed;
  width: 245px;
  text-align: left;
}
th:first-child,
td:first-child {
  width: 40px;
  padding: 0 5px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/belongs/belongEdit.vue